import React, { useState, useEffect } from 'react'
import LeftParentSidebar from './LeftParentSidebar';
import RightParentSidebar from './RightParentSidebar';
import ParentProfile from './ParentProfile';

const FatherLayout = ({children, rightParentContent, title, showWelcomeBanner, noTitle}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 1200);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div>
      {rightParentContent != null ? 
        <div className='flex h-screen'>
          <LeftParentSidebar className='w-1/4'/>
          <div className='flex-1 p-4 sm:p-6 md:p-8 overflow-y-auto'>
            { showWelcomeBanner && 
              <div className='my-4 w-full text-neutral-300 font-medium text-sm md:text-base' role='alert'>
                Hello Parents! Welcome.
              </div>
            }
            <h1 className='text-2xl md:text-3xl font-semibold text-neutral-900 mb-4'>{title}</h1>
            <div className='my-2 '>
              {children}
            </div>
            { (isMobile) && <RightParentSidebar> {rightParentContent} </RightParentSidebar> }
          </div>
          { (!isMobile) && <RightParentSidebar className='w-1/4'> {rightParentContent} </RightParentSidebar> }
        </div>
      :
        <div className='flex h-screen'>
          <LeftParentSidebar className='w-1/4'/>
          <div className='flex-1 p-4 sm:p-6 md:p-8 overflow-y-auto'>
            <div className='flex w-full justify-between items-center'>
              { showWelcomeBanner ? 
                <div className='text-neutral-300 font-medium text-sm md:text-base' role='alert'>
                  Hello Parents! Welcome.
                </div>
                : 
                (!noTitle) && <h1 className='text-2xl md:text-3xl font-semibold text-neutral-900 mb-4'>{title}</h1> 
              } 
              <div className="w-20rem"><ParentProfile /></div>
            </div>
            { (showWelcomeBanner && !noTitle) && <h1 className='text-2xl md:text-3xl font-semibold text-neutral-900 mb-4'>{title}</h1> }
            {children}
          </div>
        </div>
      }
    </div>
  )
};

export default FatherLayout;
